import { Component, OnInit, Input } from '@angular/core';
import { SmartModalService } from 'app/core/services/smart-modal.service';

@Component({
  selector: 'itpx-simple-info-edcast',
  template: `
        <p *ngIf="!data.html">{{data.text | translate}}</p>
        <div *ngIf="data.html" [innerHTML]="data.text | translate | keepHtml"></div>
        <div class="row">
            <div class="pull-right">
                <div class="button-form col-md-12">
                    <button type="button" (click)="onYes()" class="link btn btn-edcast-positive">
                        {{ data.btnYesText ? data.btnYesText :  'Yes'}}
                    </button>
                    <button type="button" (click)="onNo()" class="link btn btn-edcast-negative">
                        {{ data.btnNoText ? data.btnNoText :  'Cancel'}}
                    </button>
                </div>
            </div>
        </div>
    `,
  styleUrls: ['./simple-info-edcast.component.css']
})
export class SimpleInfoEdcastComponent {

  @Input()   private data: any;

    constructor(private modalService: SmartModalService) { }

    private onYes() {
        this.modalService.sendResult(true);
    }

    private onNo() {
        this.modalService.sendResult(null);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/simple-info-edcast/simple-info-edcast.component.ts